// resources/template-assets/js/whatsapp-widget.js

document.addEventListener('DOMContentLoaded', function() {
    const widget = document.querySelector('.whatsapp-widget');

    if (!widget) return;

    // Smooth entrance animation
    setTimeout(() => {
        widget.classList.add('show');
    }, 1000);

    // Analytics tracking on click
    const whatsappButton = widget.querySelector('.whatsapp-button');
    whatsappButton.addEventListener('click', function(e) {
        const context = widget.dataset.context || 'general';
        const eventLabel = whatsappButton.dataset.eventLabel || context;

        // Track with Google Analytics 4
        if (typeof gtag !== 'undefined') {
            gtag('event', 'whatsapp_click', {
                'event_category': 'engagement',
                'event_label': eventLabel,
                'value': context,
            });
        }

        // Track with console in development
        console.log('WhatsApp widget clicked:', {
            context: context,
            label: eventLabel,
        });
    });
});
